import type { AlphaRun, AlphaRunDesign } from "@nlc/shared-types";

export function alphaDesignName(
  { batch }: Pick<AlphaRun, "batch">,
  { planIndex }: Pick<AlphaRunDesign, "planIndex">,
): string {
  return `${batch === 1 ? "Ad" : "New ad"} ${planIndex + 1}`;
}
